import React from "react";
import { withTranslation } from 'react-i18next';
import ReactLoading from 'react-loading';
import {
  Badge,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  FormInput,
  FormSelect,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Row
} from "shards-react";

import verifyInboxService from '../../services/verifyInboxService';
import ResponsiveTable from "../responsive-table/ResponsiveTable";

class RecognitionTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      ideas: [],
      isLoading: false,
      evalCriteria: [],
      filteredIdeas: [],
      title: '',
      pageSizeOptions: [5, 10, 15, 20, 25, 30],
      pageSize: 5,
      search: ''
    };

    this.fetchIdeas = this.fetchIdeas.bind(this);
    this.handlePageSizeChange = this.handlePageSizeChange.bind(this);
    this.handleFilterSearch = this.handleFilterSearch.bind(this);
  }

  componentDidMount() {
    this.fetchIdeas();
  }

  async fetchIdeas() {
    const {isLoading} = this.state;
    if (isLoading) return;
    this.setState({ isLoading: true });
    
    try {
      const ideas = await verifyInboxService.fetchVerifyInboxIdeas('inbox');
      this.setState({ ideas, filteredIdeas: ideas });
    } catch (error) {
      this.setState({ isLoading: false });
      console.log(error);
    }finally {
      this.setState({ isLoading: false });
    }
  }

  handlePageSizeChange(e) {
    this.setState({ pageSize: e.target.value });
  }

  handleFilterSearch(e) {
    const searchTerm = e.target.value.toLowerCase();
    this.setState({ search: searchTerm }, () => {
      const filteredData = this.state.ideas.filter(idea =>
        idea.title.toLowerCase().includes(searchTerm) ||
        idea.category.toLowerCase().includes(searchTerm) ||
        idea.num == searchTerm ||
        idea.proponent.toLowerCase().includes(searchTerm) ||
        idea.status.toLowerCase().includes(searchTerm)
      );
      this.setState({ filteredIdeas: filteredData });
    });
  }

  render() {
    const {filteredIdeas, isLoading, pageSize, pageSizeOptions, search } = this.state;
    const { t } = this.props;

    const columns = [
      {
        Header: 'Actions',
        accessor: "open",
        width: 150,
        sortable: false,
        Cell: row => (<>
            <Badge pill style={{cursor:'pointer', marginRight: '10px'}}  outline   onClick={() => this.props.onViewIdeaPress(row.original.evaluate)}>
              View
            </Badge>
            <Badge style={{cursor:'pointer'}} pill outline onClick={() => {
              this.props.onEditActionPress(row.original.open)
            }}>
              Evaluate
            </Badge></>
        )
      },
      {
        Header: t("IDEA_MANAGE_NUM"),
        accessor: "num",
        className: "text-center",
        width: 120
      },
      {
        Header: t("IDEA_MANAGE_TITLE"),
        accessor: "title",
        className: "text-center"
      },
      {
        Header: t("IDEA_MANAGE_CATEGORY"),
        accessor: "category",
        style: {color: '#17c671'},
        className: "text-center"
      },
      {
        Header: t("IDEA_MANAGE_PROP"),
        accessor: "proponentName",
        className: "text-center"
      },
      {
        Header: t("IDEA_MANAGE_STATUS"),
        accessor: "status",
        width: 150,
        className: "text-center",
        Cell: row => (
          <div className="d-table mx-auto">
            <Badge pill theme={getBadgeType(row.value)}>
              {t(row.value)}
            </Badge>
          </div>
        )
      }
    ];

    const data = filteredIdeas.map(idea => ({
      open: idea,
      evaluate: idea,
      num: idea.num,
      title: idea.title,
      category: idea.category,
      proponentName: idea.proponent,
      status: idea.status,
      verified: idea.verified
    }));

    return (
     
      <Card className={'transparent-responsive-card'}>
        <CardHeader className="p-0 responsive-table-filter">
          <Container fluid className="file-manager__filters border-bottom">
            <Row>
              <Col className="file-manager__filters__rows d-flex" md="6">
                <span>{t('SHOW')}</span>
                <FormSelect
                  size="sm"
                  value={pageSize}
                  onChange={this.handlePageSizeChange}
                >
                  {pageSizeOptions.map((size, idx) => (
                    <option key={idx} value={size}>
                      {size + ' ' + t('ROWS')}
                    </option>
                  ))}
                </FormSelect>
              </Col>

              <Col className="file-manager__filters__search d-flex" md="6">
                <InputGroup seamless size="sm" className="ml-auto">
                  <InputGroupAddon type="prepend">
                    <InputGroupText>
                      <i className="material-icons">search</i>
                    </InputGroupText>
                  </InputGroupAddon>
                  <FormInput value={search} onChange={this.handleFilterSearch} />
                </InputGroup>
              </Col>
            </Row>
          </Container>
        </CardHeader>
        <CardBody className="p-0">
          <Container fluid className="px-0">
            {isLoading ? (
              <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', height: '10em' }}>
                <ReactLoading type={'spokes'} color={'#633FDA'} width={80} height={80} />
              </div>
            ) : (
              <ResponsiveTable
              columns={columns}
              data={data}
              defaultPageSize={pageSize}
              pageSize={pageSize}
              pageSizeOptions={pageSizeOptions}
              showPageSizeOptions={false}
              resizable={false}
            />)}
          </Container>
        </CardBody>
      </Card>
    );
  }
}

function getBadgeType(itemStatus) {
  const statusMap = {
    "Complete": "success",
    "Saved": "warning",
    "Canceled": "danger"
  };
  return statusMap[itemStatus];
}

export default withTranslation()(RecognitionTable);
